"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VARIANT = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedcomponents = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon-loader");

var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./FaqItem.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const VARIANT = {
  DEFAULT: 'DEFAULT',
  WITH_BORDERS: 'WITH_BORDERS'
};
exports.VARIANT = VARIANT;

const FaqItem = ({
  faqTitle,
  faqContent,
  isOpen,
  taggingInfo,
  options,
  variant,
  SvgIconLoader
}) => {
  const [isFaqShow, setIsFaqShow] = (0, _react.useState)(!!isOpen);
  const [chevronOptions, setChevronOptions] = (0, _react.useState)({
    color: options.default.color.icon
  });
  const [titleOptions, setTitleOptions] = (0, _react.useState)({
    color: options.default.color.title
  });
  const displayAnswerStatusCss = isFaqShow ? 'faq-item__chevron-icon--opened' : 'faq-item__chevron-icon';
  const displayContentCss = isFaqShow ? 'faq-item__content--opened' : 'faq-item__content';

  const onClickItem = () => {
    if (isFaqShow) {
      setIsFaqShow(false);
      setTitleOptions(_objectSpread(_objectSpread({}, titleOptions), {}, {
        color: options.default.color.title
      }));
      setChevronOptions(_objectSpread(_objectSpread({}, chevronOptions), {}, {
        color: options.default.color.icon
      }));
    } else {
      setIsFaqShow(true);
      setTitleOptions(_objectSpread(_objectSpread({}, titleOptions), {}, {
        color: options.activated.color.title
      }));
      setChevronOptions(_objectSpread(_objectSpread({}, chevronOptions), {}, {
        color: options.activated.color.icon
      }));
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
    className: `faq-item ${variant === VARIANT.DEFAULT ? 'faq-item--with-bottom-border' : 'faq-item--with-borders'}`,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "faq-item__header",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        text: faqTitle,
        kind: _gerenciatdUnifiedcomponents.KIND_TEXT.SPAN,
        align: _gerenciatdUnifiedcomponents.ALIGN.LEFT,
        color: titleOptions.color,
        size: _gerenciatdUnifiedcomponents.SIZE.CAPTION1,
        fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.REGULAR,
        className: "faq-item__title"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: displayAnswerStatusCss,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SvgIconLoader, {
          id: _gerenciatdUnifiedicons.ICONS_ID.CheuronDown,
          color: chevronOptions.color,
          kind: _gerenciatdUnifiedicons.SVG_ICON_KIND.MEDIUM
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
        isBlockElement: true,
        className: "clicable-gap",
        onClick: onClickItem,
        taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
          componentContent: `faq-${isFaqShow ? 'plegar' : 'desplegar'}`
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: displayContentCss,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        text: faqContent,
        kind: _gerenciatdUnifiedcomponents.KIND_TEXT.SPAN,
        align: _gerenciatdUnifiedcomponents.ALIGN.RIGHT,
        color: _gerenciatdUnifiedcomponents.COLOR.GREY_6,
        size: _gerenciatdUnifiedcomponents.SIZE.CAPTION2,
        fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.REGULAR
      })
    })]
  });
};

var _default = FaqItem;
exports.default = _default;
FaqItem.defaultProps = {};
FaqItem.propTypes = {
  /**
   * {
   * "info": "Booleano que nos permite abrir la pregunta po defecto"
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  isOpen: _propTypes.default.bool,

  /**
   * {
   * "info": "Titulo de la pregunta frecuente/faq,"
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  faqTitle: _propTypes.default.string.isRequired,

  /**
   * {
   * "info": "Respuesta de la  pregunta frecuente/faq. Es el texto que aparece cuando clickas sobre el titulo de cada  pregunta frecuente/faq.",
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  faqContent: _propTypes.default.string.isRequired,

  /**
   * {
   * "info": "Etiqueta de seguimiento para analitica",
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  taggingInfo: _propTypes.default.object.isRequired,

  /**
   * {
   * "info": "Opciones para cambiar los colores de cada pregunta frecuente/faq",
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  options: _propTypes.default.shape({
    /**
     * {
     * "info": "Cuando la pregunta frecuente/faq está sin abrir",
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    default: _propTypes.default.shape({
      color: _propTypes.default.shape({
        title: _propTypes.default.oneOf(Object.values(_gerenciatdUnifiedcomponents.COLOR)),
        icon: _propTypes.default.oneOf(Object.values(_gerenciatdUnifiedicons.COLOR))
      })
    }).isRequired,

    /**
     * {
     * "info": "Cuando la pregunta frecuente/faq está abierta",
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    activated: _propTypes.default.shape({
      color: _propTypes.default.shape({
        title: _propTypes.default.oneOf(Object.values(_gerenciatdUnifiedcomponents.COLOR)),
        icon: _propTypes.default.oneOf(Object.values(_gerenciatdUnifiedicons.COLOR))
      })
    })
  }).isRequired,

  /**
   * {
   * "info": "Dependiendo del tipo de "variant" se cambian los estilos del componente. Es un modificador",
   * "kind": "both",
   * "beautifulName": "",
   * "injectComponent": ""
   * }
   */
  variant: _propTypes.default.oneOf(Object.values(VARIANT)).isRequired,
  SvgIconLoader: _propTypes.default.func.isRequired
};

//# sourceMappingURL=index.js.map